import { useState } from "react";
import { getInvoiceNumbers } from "../../../../config/LiveApi";
import { toast } from "react-toastify";

const GetInvoiceNo = ({ token }) => {
  const [searchType, setSearchType] = useState("utr");
  const [inputValue, setInputValue] = useState("");
  const [invoices, setInvoices] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    try {
      setLoading(true);

      const identifiers = inputValue
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);

      const res = await getInvoiceNumbers(token, identifiers, searchType);

      setInvoices(res.data);
      setError("");
    } catch (err) {
      setInvoices([]);
      setError("Error fetching invoice numbers.");
    } finally {
      setLoading(false);
    }
  };

  const handleCopyTable = async () => {
    try {
      const tableData = [
        [searchType, "Invoice Number", "OrderId", "Transaction Id"],
        ...invoices.map((row) => [
          row.identifier ?? "",
          row.invoiceNumber ?? "",
          row.orderId ?? "",
          row.transactionId ?? "",
        ]),
      ];

      const text = tableData.map((row) => row.join("\t")).join("\n");

      await navigator.clipboard.writeText(text);
      toast.success("Table copied to clipboard!");
    } catch (err) {
      toast.error("Failed to copy table!");
    }
  };

  return (
    <>
      <div className="cbe-search-bar" style={{ display: "flex", gap: "10px" }}>
        <select
          value={searchType}
          onChange={(e) => setSearchType(e.target.value)}
        >
          <option value="utr">UTR</option>
          <option value="requestOrderId">Order ID</option>
          <option value="transactionId">Transaction ID</option>
        </select>

        <input
          type="text"
          placeholder={`Enter ${searchType}s`}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />

        <button onClick={handleSearch}>Search</button>
      </div>

      {loading && <div className="cbe-loading">🔄 Loading...</div>}

      {!loading && invoices.length > 0 && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              margin: "10px 0",
            }}
          >
            <button className="cbe-copy-btn-2" onClick={handleCopyTable}>
              Copy Table
            </button>
          </div>

          <div className="cbe-table-wrapper">
            <table className="cbe-table">
              <thead>
                <tr>
                  <th>{searchType}</th>
                  <th>Invoice Number</th>
                  <th>OrderId</th>
                  <th>Transaction Id</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map((row, index) => (
                  <tr key={index}>
                    <td>{row.identifier}</td>
                    <td>{row.invoiceNumber}</td>
                    <td>{row.orderId}</td>
                    <td>{row.transactionId}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {!loading && error && <div className="cb-error-message">{error}</div>}
    </>
  );
};

export default GetInvoiceNo;
